module.exports = __webpack_public_path__ + "media/src/application/media/img-nko-caf046ac425a405d781b53f082ea9098.jpg";